import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import 'react-multi-carousel/lib/styles.css';
import { Col, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
//api
import { getAllRelatedPost } from 'api/blog';
//custom hooks
import useAssignedLibrary from 'utils/customHooks/useAssignedLibrary';
//images
import noImagePost from 'assets/img/feather.jpg';
//styles
import './blog.scss';

const goUp = () => {
  window.scrollTo(0, 0);
};

const CardPost = (props) => {
  const {
    featured_image,
    title,
    author,
    publish_date,
    featured_paragraph,
    // slug,
    body,
    category,
    id,
  } = props.event;
  // const showRelatedBookList = display_related_book_list !== null || display_related_book_list !== undefined;

  const { t } = useTranslation(['blog']);
  const [relatedElementPost, setRelatedElementPost] = useState([]);
  const { assignedLibrary } = useAssignedLibrary();

  const getRelatedPost = async () => {
    try {
      const { data, status } = await getAllRelatedPost(id);
      if (status === 200) {
        setRelatedElementPost(data?.related_posts);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    goUp();
    getRelatedPost();
  }, [id]);

  return (
    <div className="containerPostList">
      <Row>
        <Col lg={4} className="d-none d-lg-block">
          <h2>{title}</h2>
          <p>{featured_paragraph}</p>
          <p className="post-card__detail-subtitle">
            {publish_date} {t('in')}{' '}
            <Link
              className="post-card__detail-categorylink"
              to={`/${assignedLibrary}/blog/${category?.id}/${category?.slug}/`}
              onClick={goUp}
            >
              {category?.name}
            </Link>
          </p>
          {author?.trim() && (
            <p className="title-author">
              {t('by')} {author}
            </p>
          )}
        </Col>
        <Col lg={8}>
          <img className="post-img" src={featured_image || noImagePost} alt={`${title} imagen`} />
        </Col>
        <Col sm={12} xs={12} className="d-block d-lg-none">
          <h2>{title}</h2>
          <p>{featured_paragraph}</p>
          <p className="post-card__detail-subtitle">
            {publish_date} {t('in')}{' '}
            <Link
              className="post-card__detail-categorylink"
              to={`/${assignedLibrary}/blog/${category?.id}/${category?.slug}/`}
              onClick={goUp}
            >
              {category?.name}
            </Link>
          </p>
          {author?.trim() && (
            <p className="title-author">
              {t('by')} {author}
            </p>
          )}
        </Col>
      </Row>
      <br />
      <br />
      <Row>
        <Col lg={1} className="d-none d-lg-block text-start">
          {category?.image && <img src={category.image} alt="Post" className="img-fluid w-100" />}
        </Col>
        <Col sm={12} lg={8}>
          <div className="blog-content">
            <div
              dangerouslySetInnerHTML={{
                __html: body.replace(/<h4(.*?)>(.*?)<\/h4>([\s\S]*?)(?=<h4|$)/g, (match, attrs, h4Content, content) => {
                  return `<div class="content-section"><h4${attrs}>${h4Content}</h4>${content}</div>`;
                }),
              }}
            />
          </div>
        </Col>
        <Col className="d-none d-lg-block" lg={3}>
          <h2 className="post-section">{t('interestedLists')}</h2>
          {relatedElementPost && relatedElementPost.length > 0 ? (
            relatedElementPost.map((post) => (
              <Col lg={12} className="titleColumnPostTitle author margin-top-md">
                <Row>
                  <Col lg={4}>
                    <img src={post?.featured_image || noImagePost} alt="Post" className="img-related-post" />
                  </Col>
                  <Col lg={8} className="d-flex align-items-center">
                    <Link
                      to={`/${assignedLibrary}/blog/${post.publish_date}/${post.slug}/`}
                      onClick={() => {
                        goUp();
                        window.location.href = `/${assignedLibrary}/blog/${post.publish_date}/${post.slug}/`;
                      }}
                      className="related-title"
                    >
                      <h2 className="text-start m-0">{post.title}</h2>
                    </Link>
                  </Col>
                </Row>
              </Col>
            ))
          ) : (
            <p>{t('noRelatedLists')}</p>
          )}
        </Col>
      </Row>
      <section className="margin-bottom-md list-section mx-lg-5 ">
        <Col md={12} lg={10}>
          {/*   <h3>{title}</h3> */}
        </Col>
        <Col xs={12} sm={10} md={12} lg={9} className="mx-5">
          {/* <Carousel
              responsive={responsive}
              slidesToSlide={1}
              minimumTouchDrag={40}
              draggable
              infinite={true}
              centerMode={true}
              swipeable
              className="mx-5"
            >
              {showRelatedBookList &&
                display_related_book_list.books.map((book, index) => (
                  <div key={`productItem#${index}`} className="slide-div">
                    <ItemList data={book} />
                  </div>
                ))}
            </Carousel> */}
        </Col>
      </section>
    </div>
  );
};

CardPost.propTypes = {
  event: PropTypes.object,
};
export default CardPost;
